
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from '../BaseComponent.vue';

@Component
export default class FreeTextQuestionGroup extends BaseComponent {
    @Prop() title?: string;
    @Prop() color?: string;
}
